import { qsa } from '@fluorescent/dom';
import { section } from '@/glow';

import { backgroundVideoHandler } from '@/lib/a11y';
import { AnimateMosaicGrid } from '@/lib/animation';

const selectors = {
  video: '.mosaic-grid__item-video',
};

section('mosaic-grid', {
  onLoad() {
    const videos = qsa(selectors.video, this.container);
    this.videoHandlers = [];

    if (videos.length) {
      videos.forEach(video => {
        this.videoHandlers.push(backgroundVideoHandler(video.parentNode));
      });
    }

    this.AnimateMosaicGrid = AnimateMosaicGrid(this.container);
  },

  onUnload() {
    this.videoHandlers.forEach(handler => handler());
    this.AnimateMosaicGrid?.destroy();
  },
});
